module.exports = __webpack_public_path__ + "static/media/test6_2.27d9651a.png";